export function getDateValue (datetime) {
  if (datetime) {
    datetime = new Date(datetime)
    let y = datetime.getFullYear() + "-"
    let mon = datetime.getMonth() + 1 + "-"
    let d = datetime.getDate()
    return y + mon + d
  }
  return ""
}

export function formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function filterRoutes(allRoutes, userRoutes) {
  // 递归获取用户所有URL
  function getUserUrls(routes, fatherPath = '') {
    return routes.reduce((urls, route) => {
      // 一级菜单自带 "/"  不做多的处理
      if (route.url && route.url.includes('/')){
        urls.push(route.url)
      }else if(route.url && !route.url.includes('/')){
        // 二级菜单不带 "/"  所以手动添加 "/"
        urls.push(fatherPath+'/'+route.url)
      }
      if (route.child) {
        urls.push(...getUserUrls(route.child, route.url))
      };
      return urls;
    }, []);
  }
  
  const userUrls = getUserUrls(userRoutes);
  
  // 递归过滤总路由
  function filter(allRoutes) {
    return allRoutes.filter(route => {
      // 检查当前路由是否有权限
      const hasPermission = userUrls.some(url => {
        if(route.path === '/dashboard'){
          return true
        }else{
          return route.path === url
        }
      });
      
      // 如果有children，递归过滤
      if (route.children) {
        route.children = filter(route.children);
        // 保留条件：当前路由有权限或有子路由被保留
        return hasPermission
      }
      
      return hasPermission;
    });
  }
  
  return filter(allRoutes);
}